import React, { ReactNode } from "react";
import FTSecNavOptions from "../ftConstants";
import { useRouteMatch, useParams } from "react-router-dom";
import NavigationDropdown from "../../../generic/navigationDropdown";

export interface IFtContainerMobProps {
	instComp?: ReactNode;
	dateComp?: ReactNode;
}

const FtContainerMob: React.FC<IFtContainerMobProps> = (props) => {
	const routeParams = useRouteMatch();
	const { asset } = useParams<{ asset: string }>(); //section navigation,page navigation, primary market instrument

	const defaultValue: string = routeParams.url.split("/")[2] + (asset ? asset : "");
	return (
		<section className={"outer_container container_mob"}>
			<section className="lyCont">
				<section className="ly_view_mob ">
					<div className={" ly_mob_hdr "}>
						<div className="but_container nav_date_wrapper">
							<div className={"ly_title "}>
								<NavigationDropdown
									type="sec_nav"
									defaultValue={defaultValue}
									dropdownOptions={FTSecNavOptions()}
									onSelect={() => {}}
								/>
							</div>
							{props.dateComp}
						</div>
					</div>
					<div className={"ly_content_mob ftForm"}>{props.instComp}</div>
				</section>
			</section>
		</section>
	);
};

export default FtContainerMob;
